export const AddButtonClasses = `
    shadow-md
    self-start
`
